import script from "./Weight.vue?vue&type=script&setup=true&lang=ts"
export * from "./Weight.vue?vue&type=script&setup=true&lang=ts"

import "./Weight.vue?vue&type=style&index=0&id=d0eb7828&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0eb7828"]])

export default __exports__